export default __webpack_public_path__ + "static/media/StaticPage6.d17e3b6f.txt";